<!--
  https://xylo.codesinn.com/api/gcl/seeactivereq/d86f4d7f-65d3-413e-aed4-2ae3816d5145
https://xylo.codesinn.com/api/gcl/deletereq/7b140c75-2b21-42aa-a2a0-f051a335cab5/d86f4d7f-65d3-413e-aed4-2ae3816d5145
-->
<template>
  <div id="knowledge-base-page">
    <div class="knowledge-base-jumbotron">
      <div class="knowledge-base-jumbotron-content lg:p-8 md:p-24 sm:p-16 p-8 rounded-lg mb-base" style="height:150px">
        <h1 class="mb-1 text-white"><feather-icon icon="KeyIcon" class="w-5 h-5 mr-1"></feather-icon>Restricted
          Area</h1>
        <p class="text-white">This software section is securely protected with strong encryption, ensuring your data is
          safe.</p>
      </div>
    </div>
    <div class="vx-row" v-if="connectedbankandaccount && connectedbankandaccount.length > 0">
      <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base" v-for="item in connectedbankandaccount" :key="item.idaccount"
        @click="openTransactions(item)">
        <vx-card class="text-center cursor-pointer">
          <small v-if="item.status === 'UA'">Status: UNDERGOING AUTHENTICATION <br /><a :href="item.linkifua">Continue
              Procedure</a><br /></small>
          <small v-else-if="item.status === 'GC'">Status: GIVING CONSENT <br /><a :href="item.linkifua">Continue
              Procedure</a><br /></small>
          <small v-else-if="item.status === 'RJ'">Status: REJECTED <br /><a :href="item.linkifua">Continue
              Procedure</a><br /></small>
          <small v-else-if="item.status === 'SA'">Status: SELECTING ACCOUNT <br /><a :href="item.linkifua">Continue
              Procedure</a><br /></small>
          <small v-else-if="item.status === 'GA'">Status: GRANTING ACCESS<br /><a :href="item.linkifua">Continue
              Procedure</a><br /></small>
          <small v-else-if="item.status === 'EX'">Status: EXPIRED <br /><a :href="item.linkifua">Restart
              Procedure</a><br /></small>
          <!--<small v-else>Status: {{ item.status }} <a :href="item.linkifua">Restart Procedure</a></small>-->

          <img :src="item.gcl_logo" alt="graphic" class="mx-auto mb-4" style="height:150px">
          <h4 class="mb-2">{{ item.gcl_name.toUpperCase() }}</h4>
          <small>{{ item.gcl_iban }}</small><br /><big><b v-if="item.gcl_balance != 0">{{ item.gcl_balance }} {{
              item.gcl_currency }}</b><b v-else-if="item.gcl_iban">0.00 {{
              item.gcl_currency }}</b><b v-else>- {{
              item.gcl_currency }}</b></big>&nbsp; <small
            v-if="item.gcl_iban && item.gcl_name == 'iBanFirst'">(2)</small><small
            v-else-if="item.gcl_iban && isManualBank(item)">(3)</small><small
            v-else-if="item.gcl_iban">(1)</small><br />
          <vs-button v-if="item.gcl_iban && item.gcl_accountid && !isManualBank(item)" size="small" type="flat" color="primary"
            icon-pack="feather" class="mt-2"
            :icon="refreshingId === item.gcl_accountid ? 'icon-loader' : 'icon-refresh-cw'"
            :disabled="refreshingId === item.gcl_accountid"
            @click.stop="refreshOneAccount(item)">{{ refreshingId === item.gcl_accountid ? 'Refreshing…' : 'Refresh'
            }}</vs-button>
          <vs-button v-if="item.gcl_bankid" size="small" type="flat" color="danger" icon-pack="feather"
            icon="icon-trash-2" class="mt-2" @click.stop="askDeleteConnection(item)">Delete</vs-button>
        </vx-card>
      </div>
    </div>
    <div v-else>
      <!--<vx-card>
        To begin enjoying your bank services, please navigate to <strong>Settings > Connect Banks</strong> and connect
        your bank account.
      </vx-card>-->

    </div>
    <div>
      <i><small>(1)</small> Balances and transactions are refreshed asynchronously every two hours</i>
    </div>
    <div>
      <i><small>(2)</small> Updates occur daily at 2:00 a.m. Romanian Time.</i>
    </div>
    <div>
      <i><small>(3)</small> Loaded manually from the bank statements — no automatic refresh.</i>
    </div>
    <div class="demo-alignment" style="padding-top:300px">
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-settings"
        @click="popupParameterActive = true">Settings</vs-button>
    </div>

    <!-- New Account -->
    <vs-popup title="Connect Account" :active.sync="popupActiveAccount">
      <div v-if="accounttoconnect && accounttoconnect.length > 0">
        <div v-for="(account, index) in accounttoconnect" :key="index" class="institution">
          <div class="institution-info">
            <div><strong>Iban :</strong> {{ account.account.iban }}</div>
            <div><strong>Name :</strong> {{ account.account.name }}</div>
            <div><strong>Currency :</strong> {{ account.account.currency }}</div>
          </div>
          <!--<vs-button type="border" class="vs-button" @click="connectAccount(account.account.id)">Connect</vs-button>-->
        </div>
        <div>
        </div>
      </div>
      <div v-else>
        <h3 style="text-align:center">Please wait... we are connecting your account(s)</h3>
      </div>
    </vs-popup>
    <!-- New Bank -->
    <vs-popup title="Connect Banks" :active.sync="popupActive">
      <div>
        <div class="demo-alignment mb-8" style="justify-content: center;">
          <vs-button color="primary" icon-pack="feather" icon="icon-unlock"
            @click="loadingInstitutions('ro')">Romania</vs-button>
          <vs-button color="primary" icon-pack="feather" icon="icon-unlock"
            @click="loadingInstitutions('be')">Belgium</vs-button>
          <vs-button color="primary" icon-pack="feather" icon="icon-unlock"
            @click="loadingInstitutions('fr')">France</vs-button>
        </div>
        <div v-for="(institution, index) in institutiondata" :key="index" class="institution">
          <img width="64px" :src="institution.logo" alt="Logo de l'institution" />
          <div class="institution-info">
            <div><strong>Name :</strong> {{ institution.name }}</div>
            <div><strong>BIC :</strong> {{ institution.bic }}</div>
          </div>
          <vs-button type="border" class="vs-button"
            @click="sendUserAgreement(institution.id, institution.bic, institution.name, institution.logo)">Agreement</vs-button>
        </div>
        <div>
        </div>
      </div>
    </vs-popup>
    <!-- View Extras -->
    <vs-popup fullscreen :title="clickbank_iban" :active.sync="popupExtrasActive">
      <div>
        <vx-card class="text-center cursor-pointer">
          <img :src="clickbank_logo" alt="logo" width="100" class="mx-auto mb-4">
          <h4 class="mb-2">{{ clickbank_iban }}<br /> <big> {{ clickbank_balance }} {{ clickbank_currency }} </big></h4>
        </vx-card>
        <h3 class="mb-4 mt-4">Transactions</h3>
        <div v-for="(tra, index) in transactions" :key="index" class="institution">
          <div class="institution-info">
            <div v-if="tra.gcl_debtorname && tra.gcl_creditorname"><strong>Name : </strong> {{ tra.gcl_debtorname }} →
              {{
              tra.gcl_creditorname }}</div>
            <div><strong>Amount : </strong> <span v-if="tra.gcl_amount > 0" style="color:green">{{ tra.gcl_amount }} {{
              clickbank_currency }}</span><span v-else style="color:red">{{ tra.gcl_amount }} {{ clickbank_currency
                }}</span></div>
            <div><strong>Date : </strong> {{ tra.gcl_bookingdate }}</div>
            <div><strong>Comment : </strong> {{ tra.gcl_comment }}</div>
          </div>
        </div>
      </div>
    </vs-popup>
    <!-- Delete connection (PIN protected) -->
    <vs-popup title="Delete bank connection" :active.sync="pinPopupActive">
      <div style="text-align:center">
        <p v-if="accountToDelete">You are about to permanently remove the connection for
          <b>{{ accountToDelete.gcl_name }}</b><span v-if="accountToDelete.gcl_iban"> ({{ accountToDelete.gcl_iban
            }})</span>.</p>
        <p><small>Transactions history is kept. Enter the PIN code to confirm.</small></p>
        <vs-input type="password" placeholder="PIN code" v-model="pinCode" class="mt-4"
          @keyup.enter="confirmDeleteConnection" />
        <br />
        <vs-button color="danger" type="filled" class="mt-4" :disabled="deleting"
          @click="confirmDeleteConnection">{{ deleting ? 'Deleting…' : 'Delete connection' }}</vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Settings" :active.sync="popupParameterActive">
      <div>
        <div class="demo-alignment mb-8" style="justify-content: center;">
          <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus"
            @click="popupActive = true; popupParameterActive = false">Connect
            Bank</vs-button>
          <vs-button v-for="(bank, index) in connectedbank" :key="index" type="border" class="vs-button" color="danger"
            icon-pack="feather" icon="icon-plus"
            @click="popupActiveAccount = true; loadAccount(bank.gcl_id); popupParameterActive = false">Connect {{
              bank.gcl_name }}
            Account</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleBankList from "@/store/bank/moduleDataList.js";
import { Row } from "jspdf-autotable";

export default {
  data() {
    return {
      activeRequisition: [],
      clickbank_currency: '',
      clickbank_logo: '',
      clickbank_balance: '',
      clickbank_iban: '',
      countryinst: '',
      institutiondata: {},
      popupActive: false,
      popupExtrasActive: false,
      popupActiveAccount: false,
      popupParameterActive: false,
      knowledgeBaseSearchQuery: '',
      connectedbankandaccount: [],
      accounttoconnect: [],
      transactions: [],
      connectedbank: {},
      refreshingId: null,
      pinPopupActive: false,
      pinCode: '',
      accountToDelete: null,
      deleting: false,
    }
  },
  computed: {
    filteredKB() {
      return this.kb.filter((item) => item.title.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()) || item.description.toLowerCase().includes(this.knowledgeBaseSearchQuery.toLowerCase()))
    }
  },
  methods: {
    // Banques alimentées hors GoCardless (extraits PDF, mails) : pas de bouton Refresh.
    isManualBank(item) {
      return ["ibanfirst", "brd_extras"].includes(String(item.gcl_bankid || "").toLowerCase());
    },
    openTransactions(item) {
      this.fetchTransactions(item.idaccount);
      this.setVariable(item.gcl_iban, item.gcl_currency, item.gcl_balance, item.gcl_logo);
      if (item && item.gcl_iban) this.popupExtrasActive = true;
      else {
        this.$vs.notify({
          color: "danger",
          title: "No account.",
          text: "The bank connection has not been established correctly. Please contact your developer.",
        });
      }
    },
    setVariable(iban, currency, balance, logo) {
      this.clickbank_currency = currency
      this.clickbank_logo = logo
      this.clickbank_balance = balance
      this.clickbank_iban = iban
    },
    fetchTransactions(id) {
      this.$store
        .dispatch("BankList/fetchTransactions", { id })
        .then(res => {
          this.transactions = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    refreshOneAccount(item) {
      if (!item || !item.gcl_accountid || this.refreshingId) return;
      this.refreshingId = item.gcl_accountid;
      this.$store
        .dispatch("BankList/refreshAccount", { accountid: item.gcl_accountid })
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Account refreshed",
            text: "Balance and transactions have been updated.",
          });
          this.loadingConnectedBankAndAccount();
          if (this.popupExtrasActive && this.clickbank_iban === item.gcl_iban) {
            this.fetchTransactions(item.idaccount);
          }
        })
        .catch(err => {
          let msg = "Could not refresh this account. Please try again.";
          if (err && err.response && err.response.status === 429) {
            msg = "Please wait a moment before refreshing this account again.";
          }
          this.$vs.notify({ color: "warning", title: "Refresh", text: msg });
        })
        .finally(() => {
          this.refreshingId = null;
        });
    },
    updateBalance() {
      this.$store
        .dispatch("BankList/updateBalance")
        .then(res => {
          this.loadingConnectedBankAndAccount();
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateTransactions() {
      this.$store
        .dispatch("BankList/updateTransactions")
        .then(res1 => {
          this.$vs.notify({
            color: "success",
            title: "account update",
            text: "GCL accounts updated",
          });
          this.$store
            .dispatch("BankList/updateIbanFirst")
            .then(res2 => {
              this.$vs.notify({
                color: "success",
                title: "account update",
                text: "IBANFIRST accounts updated",
              });

            })
            .catch(err2 => {
              console.error(err2);
            });
        })
        .catch(err1 => {
          console.error(err1);
        });
    },
    askDeleteConnection(item) {
      this.accountToDelete = item;
      this.pinCode = '';
      this.pinPopupActive = true;
    },
    confirmDeleteConnection() {
      if (!this.accountToDelete || !this.accountToDelete.gcl_bankid || this.deleting) return;
      this.deleting = true;
      this.$store
        .dispatch("BankList/deleteConnection", {
          bankid: this.accountToDelete.gcl_bankid,
          pin: this.pinCode,
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Connection deleted",
            text: "The bank connection has been removed. Transaction history was kept.",
          });
          this.pinPopupActive = false;
          this.accountToDelete = null;
          this.pinCode = '';
          this.loadingConnectedBankAndAccount()
            .then(() => this.loadingActiveRequisition());
          this.loadingConnectedBank();
        })
        .catch(err => {
          let msg = "Could not delete the connection. Please try again.";
          if (err && err.response && err.response.status === 403) {
            msg = "Invalid PIN code.";
          }
          this.$vs.notify({ color: "danger", title: "Delete connection", text: msg });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
    loadAccount(bank_id) {
      this.$store
        .dispatch("BankList/fetchAccounts", bank_id)
        .then(res => {
          this.accounttoconnect = res.data;
          location.reload()
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Connect account",
            text: "Could not connect the account. Please retry in a moment.",
          });
        });
    },
    sendUserAgreement(institution_id, gcl_bic, gcl_name, gcl_logo) {
      if (institution_id) {
        this.$store
          .dispatch("BankList/createAgreement", { institution_id, gcl_bic, gcl_name, gcl_logo })
          .then(res => {
            this.institutiondata = res.data;
          })
          .catch(err => {
            console.error(err);
            this.$vs.notify({
              color: "danger",
              title: "Bank connection",
              text: "Could not start the connection with this bank. Please try again.",
            });
          });
      }
    },
    loadingConnectedBankAndAccount() {
      return this.$store
        .dispatch("BankList/fetchConnectedAccountAndBankData")
        .then(res => {
          this.connectedbankandaccount = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: "Bank accounts",
            text: "Could not load your connected bank accounts.",
          });
        });
    },
    loadingConnectedBank() {
      this.$store
        .dispatch("BankList/fetchConnectedBankData")
        .then(res => {
          this.connectedbank = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    loadingInstitutions(countryinst) {
      if (countryinst) {
        this.$store
          .dispatch("BankList/fetchInstitutions", countryinst)
          .then(res => {
            this.institutiondata = res.data;
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    loadingActiveRequisition() {
      return this.$store
        .dispatch("BankList/loadActiveRequisition")
        .then(res => {
          this.activeRequisition = (res.data && res.data.results) || [];
          if (!Array.isArray(this.connectedbankandaccount)) return;
          // Enrichir chaque compte connecté avec le statut/lien de sa requisition
          this.activeRequisition.forEach(requisition => {
            this.connectedbankandaccount.forEach(connected => {
              if (connected.gcl_req_id === requisition.id) {
                connected.status = requisition.status;
                connected.linkifua = requisition.link;
              }
            });
          });
          // Forcer la réactivité Vue 2 (mutation en place des objets du tableau)
          this.connectedbankandaccount = [...this.connectedbankandaccount];
        })
        .catch(err => {
          console.error(err);
        });
    },

    handleButtonClick(event, path) {
      if (event.ctrlKey || event.metaKey) {
        window.open(path, '_blank');
      } else {
        this.$router.push(path);
      }
    }
  },
  created() {
    /*this.$vs.notify({
      color: "success",
      title: "Refreshing...",
        iconPack: "feather",
        icon: "icon-download-cloud",
      text: "Please wait while we refresh the content...",
      time: 8000,
    });*/
    if (!localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/" });
    }
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule("BankList", moduleBankList);
      moduleBankList.isRegistered = true;
    }
    try {
      // Charger les comptes AVANT d'enrichir avec les statuts de requisition,
      // sinon la fusion s'applique sur un tableau vide (badges de statut qui disparaissent).
      this.loadingConnectedBankAndAccount()
        .then(() => this.loadingActiveRequisition())
        .catch(error => console.error("Error loading bank data:", error));
      try { this.loadingConnectedBank() } catch (error) { console.error("Error loading connected bank:", error) }
    } catch (error) {
      console.error("Error in component created hook:", error);
    }
  },
  components: {}
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
  background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
  background-size: cover;
  height: 250px;
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}
</style>
